import { render } from "./FormationDetailLayout.vue?vue&type=template&id=67b91afb"
import script from "./FormationDetailLayout.vue?vue&type=script&lang=js"
export * from "./FormationDetailLayout.vue?vue&type=script&lang=js"

import "./FormationDetailLayout.vue?vue&type=style&index=0&id=67b91afb&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__